export default "__VITE_ASSET__CTR4EpEv__"